import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Table from '@shared/components/Table';
import DeleteModal from '@shared/components/DeleteModal';
import EducationForm from './EducationForm';
import { useEducationalDegree } from '@modules/staff/educationalDegree/hooks/useEducationalDegree';
import { educationService } from '../services/educationService';
import { useStatusBadge } from '@shared/components/StatusBadge';

export default function EducationalDegree() {
    const { t } = useTranslation();
    const { statusBadge } = useStatusBadge();
    const {
        modalState,
        handleOpenModal,
        handleCloseModal,
        selectedDegree,
        setSelectedDegree,
        data,
        pageNumber,
        selectedData,
        setSelectedData,
        pageSize,
        searchQuery,
        searchType,
        totalPages,
        totalElements,
        sortDir,
        setSearchQuery,
        setSearchType,
        handleSearchClick,
        fetchData,
        handleSort,
        setPageSize,
        setpageNumber,
        handleEditDegree,
        handleConfirmDelete,
        searchOptions,
        refreshData
    } = useEducationalDegree();

    const columns = [
        { key: 'code', label: t('education.table.headers.code'), sortable: true },
        { key: 'education', label: t('education.table.headers.education'), sortable: true },
        { key: 'degreeLevel', label: t('education.table.headers.degree'), sortable: true },
        { key: 'addCode', label: t('education.table.headers.collectCode'), sortable: true },
        { key: 'addLevel', label: t('education.table.headers.collectLevel'), sortable: true },
        { key: 'active', label: t('education.table.headers.active'), sortable: true },
        { key: 'ordno', label: t('education.table.headers.ordno'), sortable: true }
    ];

    const actionButtons = (
        <>
            <button
                className="icon-button"
                onClick={() => handleOpenModal('add')}
                title={t('common.add')}
            >
                <FontAwesomeIcon icon={faPlus} />
            </button>

            <button
                className={`icon-button ${!selectedData ? 'disabled-link' : ''}`}
                onClick={handleEditDegree}
                title={t('common.edit')}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>

            <button
                className={`icon-button delete ${!selectedData ? 'disabled-link' : ''}`}
                onClick={() => selectedData && handleOpenModal('delete')}
                title={t('common.remove')}
            >
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </>
    );

    const handleCheckboxChange = (index) => {
        const degree = data[index];
        setSelectedData(selectedData === degree.id ? null : degree.id);
    };

    return (
        <>
            <Table
                // Data and state
                data={data}
                loading={false}
                error={null}
                selectedData={selectedData}
                pageNumber={pageNumber}
                pageSize={pageSize}
                sortBy={'code'}
                sortDir={sortDir}
                totalElements={totalElements}
                totalPages={totalPages}
                searchQuery={searchQuery}
                searchType={searchType}
                searchOptions={searchOptions}

                // Column configuration
                columns={columns}

                // Title and actions
                title={t('education.title')}
                actionButtons={actionButtons}

                // Handlers
                handleSort={handleSort}
                handleCheckboxChange={handleCheckboxChange}
                handleSearchClick={handleSearchClick}
                setSearchQuery={setSearchQuery}
                setSearchType={setSearchType}
                setPageSize={setPageSize}
                setpageNumber={setpageNumber}
                getData={educationService.getDegrees}

                // Custom renderers
                renderCell={(item, column) => statusBadge(item, column)}
            />

            {modalState.visible && modalState.type === 'delete' && (
                <DeleteModal
                    onClose={handleCloseModal}
                    onConfirm={handleConfirmDelete}
                    name={data?.find(item => item.id === selectedData)?.education || ''}
                    entityType="record"
                />
            )}

            {modalState.visible && (modalState.type === 'add' || modalState.type === 'edit') && (
                <EducationForm
                    degree={modalState.type === 'edit' ? selectedDegree : null}
                    onClose={() => {
                        handleCloseModal();
                        setSelectedDegree(null);
                    }}
                    selectedData={selectedData}
                    fetchData={refreshData}
                />
            )}
        </>
    );
}

